import { InteractiveLinkWidget } from '@tableau/widgets';
import * as React from 'react';
import * as _ from 'underscore';
import { Messages } from '../../../codegen/Localize';
import { ISanitizer } from '../../../commonInfra/utils/Sanitize';
import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import { L10n } from '../../../ts/L10n/L10n';
import { SpaceHeaderTestIds } from './SpaceHeader';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

export const maxDescriptionLength = 180;

export function ItemDescription(
  item: { description: string },
  openDetail: () => void,
  sanitizer: ISanitizer
): JSX.Element {
  let descriptionPlaintext = TextileHelper.getPlainTextFromTextile(item.description, sanitizer);
  let isDescriptionLong = descriptionPlaintext.length > maxDescriptionLength;

  if (_.isEmpty(descriptionPlaintext)) {
    return null;
  }

  return (
    <div data-tb-test-id={SpaceHeaderTestIds.description}
              className={SpaceHeaderStyles.ItemDescription}>
      { L10n.elideIfLong(descriptionPlaintext, maxDescriptionLength) }
      { isDescriptionLong && <ReadMoreLink onClick={openDetail} /> }
    </div>
  );
}

export interface ReadMoreButtonProps {
  readonly onClick: () => void;
}

export function ReadMoreLink(props: ReadMoreButtonProps) {
  return <InteractiveLinkWidget
    onClick={props.onClick}
    testId={SpaceHeaderTestIds.readMore}
    href="javascript:;"  // don't want a link and don't want clicking this to add to the history
    text={Messages.description_readMore()}
    style={SpaceHeaderStyles.headerLinkStyle}
  />;
}
